// Angular Import
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// project import
import { AdminComponent } from './theme/layout/admin/admin.component';
import { GuestComponent } from './theme/layout/guest/guest.component';
import { AuthGuardChild } from './theme/shared/_helpers/auth.guard';
import { Role } from './theme/shared/_helpers/role';
import { AuthSetPassword } from './demo/pages/authentication/auth-set-password/auth-set-password';
const routes: Routes = [
  {
    path: '',
    component: GuestComponent,
    children: [
      // {
      //   path: '',
      //   loadComponent: () => import('./demo/pages/landing/landing.component').then((c) => c.LandingComponent)
      // },
      {
        path: '',
        loadComponent: () =>
          import('./demo/pages/authentication/auth-signin-v2/auth-signin-v2.component').then((c) => c.AuthSigninV2Component)
      },
      {
        path: 'login',
        loadComponent: () =>
          import('./demo/pages/authentication/auth-signin-v2/auth-signin-v2.component').then((c) => c.AuthSigninV2Component)
      },
      {
        path: 'register',
        loadComponent: () =>
          import('./demo/pages/authentication/auth-signup-v2/auth-signup-v2.component').then((c) => c.AuthSignupV2Component)
      },
      {
        path: 'reset-password',
        loadComponent: () =>
          import('./demo/pages/authentication/auth-reset-password-v2/auth-reset-password-v2.component').then(
            (c) => c.AuthResetPasswordV2Component
          )
      },
      { path: 'set-password', component: AuthSetPassword },

      {
        path: 'landing',
        loadComponent: () => import('./demo/pages/landing/landing.component').then((c) => c.LandingComponent)
      },
      {
        path: 'auth',
        canActivateChild: [AuthGuardChild],
        loadChildren: () => import('./demo/pages/authentication/authentication.module').then((m) => m.AuthenticationModule),
        data: { roles: [Role.Admin, Role.SuperAdmin] }
      },

      {
        path: 'unauthorized',
        loadComponent: () =>
          import('./demo/pages/maintenance/un-authorized-page/un-authorized-page.component').then((c) => c.UnAuthorizedPageComponent)
      }
    ]
  },
  {
    path: 'admin',
    component: AdminComponent,
    canActivateChild: [AuthGuardChild],
    children: [

      {
        path: 'dev_mgmt',
        canActivateChild: [AuthGuardChild],
        loadChildren: () => import('./project_files/devices/device-module').then((m) => m.DeviceMgmtModule),
        data: { roles: [Role.Admin, Role.SuperAdmin] }
      },
      {
        path: 'client_users',
        canActivateChild: [AuthGuardChild],
        loadChildren: () => import('./project_files/user_management/user-managment-module').then((m) => m.UserModule),
        data: { roles: [Role.Admin, Role.SuperAdmin] }
      },
      {
        path: 'company',
        canActivateChild: [AuthGuardChild],
        loadChildren: () => import('./project_files/company_management/company-management-module').then((m) => m.CompanyManagementModule),
        data: { roles: [Role.Admin, Role.SuperAdmin] }
      },
      {
        path: 'roles',
        canActivateChild: [AuthGuardChild],
        loadChildren: () => import('./project_files/role_management/role-management-module').then((m) => m.RoleManagementModule),
        data: { roles: [Role.Admin, Role.SuperAdmin] }
      },
      {
        path: 'department',
        canActivateChild: [AuthGuardChild],
        loadChildren: () =>
          import('./project_files/department_management/department-management-module').then((m) => m.DepartmentManagementModule),
        data: { roles: [Role.Admin, Role.SuperAdmin] }
      },
      {
        path: 'terms-and-conditions',
        canActivateChild: [AuthGuardChild],
        loadChildren: () =>
          import('./project_files/terms_and_conditions_management/terms-and-conditions-management-module').then(
            (m) => m.TermsAndConditionsManagementModule
          ),
        data: { roles: [Role.Admin, Role.SuperAdmin] }
      },
      {
        path: 'subscription-plan',
        canActivateChild: [AuthGuardChild],
        loadChildren: () =>
          import('./project_files/subscription_plan_management/subscription-plan-management-module').then(
            (m) => m.SubscriptionPlanManagementModule
          ),
        data: { roles: [Role.Admin, Role.SuperAdmin] }
      },
      {
        path: 'company-subscription-plan',
        canActivateChild: [AuthGuardChild],
        loadChildren: () =>
          import('./project_files/company_subscription_management/company-subscription-management-module').then(
            (m) => m.CompanySubscriptionManagementModule
          ),
        data: { roles: [Role.Admin, Role.SuperAdmin] }
      },
      {
        path: 'company-subscription-invoice',
        canActivateChild: [AuthGuardChild],
        loadChildren: () =>
          import('./project_files/subscription_invoice_management/subscription-invoice-management-module').then(
            (m) => m.SubscriptionInvoiceManagementModule
          ),
        data: { roles: [Role.Admin, Role.SuperAdmin] }
      },
      {
        path: 'admin_users',
        canActivateChild: [AuthGuardChild],
        loadChildren: () =>
          import('./project_files/admin_user_management/admin-user-management-module').then((m) => m.AdminUserManagementModule),
        data: { roles: [Role.Admin, Role.SuperAdmin] }
      },
      {
        path: 'menu_mgmt',
        canActivateChild: [AuthGuardChild],
        loadChildren: () => import('./project_files/menu_access_mgmt/menu_access_mgmt-module').then((m) => m.MenuAccessMgmtModule),
        data: { roles: [Role.Admin, Role.SuperAdmin] }
      },
      {
        path: 'module_mgmt',
        canActivateChild: [AuthGuardChild],
        loadChildren: () => import('./project_files/module_mgmt/module_mgmt-module').then((m) => m.ModuleMgmtModule),
        data: { roles: [Role.Admin, Role.SuperAdmin] }
      },
      {
        path: 'export',
        canActivateChild: [AuthGuardChild],
        loadChildren: () => import('./project_files/company_export_managmenet/export-managment-module').then((m) => m.ExportModule),
        data: { roles: [Role.Admin, Role.SuperAdmin] }
      },
      {
        path: 'api_mgmt',
        canActivateChild: [AuthGuardChild],
        loadChildren: () => import('./project_files/api_management/api_management-module').then((m) => m.ApiMgmtModule),
        data: { roles: [Role.Admin, Role.SuperAdmin] }
      },
      {
        path: 'tenant_config',
        canActivateChild: [AuthGuardChild],
        loadChildren: () => import('./project_files/tenant_admin_config/api_management-module').then((m) => m.TenantAdminConfigModule),
        data: { roles: [Role.Admin, Role.SuperAdmin] }
      },
      {
        path: 'activity-log',
        canActivateChild: [AuthGuardChild],
        loadChildren: () => import('./project_files/activity-log/activity-log-module').then((m) => m.ActivityLogModule),
        data: { roles: [Role.Admin, Role.SuperAdmin] }
      },
      {
        path: 'ip-address-mgmt',
        canActivateChild: [AuthGuardChild],
        loadChildren: () =>
          import('./project_files/company_ip_address_management/company-ip-address-management-module').then(
            (m) => m.CompanyIpAddressManagementModule
          ),
        data: { roles: [Role.Admin, Role.SuperAdmin] }
      },
      {
        path: 'api-exception-monitoring',
        canActivateChild: [AuthGuardChild],
        loadChildren: () =>
          import('./project_files/api_exception_monitoring/api-exception-monitoring-module').then((m) => m.ApiExceptionMonitoringModule),
        data: { roles: [Role.Admin, Role.SuperAdmin] }
      },
      {
        path: 'login-logout-report-activity-log',
        canActivateChild: [AuthGuardChild],
        loadChildren: () =>
          import('./project_files/login_logout_report_activity_log/login-logout-report-activity-log-module').then(
            (m) => m.LoginLogoutReportActivityLogModule
          ),
        data: { roles: [Role.Admin, Role.SuperAdmin] }
      },
      {
        path: 'performance-monitoring',
        canActivateChild: [AuthGuardChild],
        loadChildren: () =>
          import('./project_files/performance_monitoring/performance-monitoring.module').then((m) => m.PerformanceMonitoringModule),
        data: { roles: [Role.Admin, Role.SuperAdmin] }
      },
      {
        path: 'server-performance-monitoring',
        canActivateChild: [AuthGuardChild],
        loadChildren: () =>
          import('./project_files/server-performance/server-monitoring.module').then((m) => m.ServerMonitoringModule),
        data: { roles: [Role.Admin, Role.SuperAdmin] }
      },
      
      {
        path: 'dashboard-monitoring',
        canActivateChild: [AuthGuardChild],
        loadChildren: () => import('./demo/dashboard/dashboard-routing.module').then((m) => m.DashboardRoutingModule),
        data: { roles: [Role.Admin, Role.SuperAdmin] }
      }
    ]
  },
  {
    path: '**',
    loadComponent: () => import('./demo/pages/maintenance/error404-page/error404-page.component').then((c) => c.Error404PageComponent)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
